import {
  clearAccess,
  revalidateAccess,
  syncGainedAccess,
  syncLostAccess,
} from 'dashboard/permissionSets/accessActions';
import { revalidateOnReconnect } from 'dashboard/permissionSets/reconnectActions';
import management from './permissionSets/management';

export default {
  namespaced: true,
  modules: { management },
  actions: {
    clearAccess,
    revalidateAccess,
    revalidateOnReconnect,
    syncGainedAccess,
    syncLostAccess,
  },
};
